import { v4 as uuidv4 } from "uuid";
import {
  Document,
  PaletteResponse,
  ProjectMediaResponse,
  StoryboardHighlights,
} from "../../types";

export const buildLivePublicationData = (
  storyboardHighlights: StoryboardHighlights,
  projectMedia: ProjectMediaResponse,
  projectDocument: Document,
  brandKitPalette: PaletteResponse,
  projectId: string
) => {
  let blobUrl = null;
  if (storyboardHighlights) {
    const jsonBlob = new Blob([JSON.stringify(storyboardHighlights)], {
      type: "application/json",
    });
    blobUrl = URL.createObjectURL(jsonBlob);
  }

  return {
    project_id: projectId,
    instance_id: projectMedia.instance_id,
    media: {
      id: projectMedia.id,
      organization: "-",
      key: "",
      url: projectMedia.url,
      status: projectMedia.status,

      created: projectMedia.created,
      project_id: projectId,
    },
    assets: {
      Highlights_0: {
        id: uuidv4(),
        description: "highlights",
        category: "MediaMeta",
        sub_category: uuidv4(),
        asset_type: "Highlights",
        owner_account: "-",
        source_type: "Generated",
        source: "LibertifyDocumentToMedia",
        path: blobUrl,
        approved: true,
        introduction: false,
      },
    },
    documents: {
      Document_0: projectDocument,
    },
    palette: {
      id: uuidv4(),
      organization_id: "-",
      ...brandKitPalette,
    },
    document_animation: {
      document_id: projectDocument.id,
      cuepoints: null,
      highlights: {
        id: uuidv4(),
        description: "highlights",
        category: "MediaMeta",
        sub_category: uuidv4(),
        asset_type: "Highlights",
        owner_account: "-",
        source_type: "Generated",
        source: "LibertifyDocumentToMedia",
        path: blobUrl,
        approved: true,
        introduction: false,
      },
    },
    tags: [],
  };
};
